import {NinchatState} from 'api/types'
import {createSelector} from '@reduxjs/toolkit'

export const getPermissions = createSelector([
    ({ninchat}: {ninchat: NinchatState}) => ninchat,
    (_state, realmId) => realmId,
],
(ninchat, realmId) => ninchat.session_realms_permissions?.[realmId] || [])

export const getUserRealm = createSelector([
    ({ninchat}: {ninchat: NinchatState}) => ninchat,
    (_state, realmId) => realmId,
],
(ninchat, realmId) => ninchat.user_realms?.[realmId] || ninchat._realms?.[realmId] || null)

